<template>
  <form>
    <vnt-input v-if="itemId" type="date" :value="item.date" label="Date" disabled />
    <vnt-calendar-datepicker v-else v-model="item.date" label="Date" />

    <vnt-input v-model="item.amount" type="number" label="Amount" placeholder="0.00" autofocus />
    <vnt-input v-model="item.description" type="text" label="Description"/>
    <vnt-select v-model="item.category" label="Category" :options="categories"
        optionValue="name" optionText="name" class="form-element"/>
    <vnt-select v-model="item.type" label="Type" :options="typeOptions" class="form-element" />
    <footer>
      <vnt-button :click="handleCancel">Cancel</vnt-button>
      <vnt-button v-if="itemId" :click="handleRemove">Remove</vnt-button>
      <vnt-button primary :click="handleSave">Save</vnt-button>
    </footer>
  </form>
</template>

<script>
import { DateTime } from 'luxon'
import { create } from '@mizz/penny-core/entities/item'
import { ITEM_TYPE } from '@mizz/penny-core/entities/itemType'
import { listCategories } from '../../services/categories'
import { save, getById, remove } from '../../services/items'

export default {
  name: 'ItemForm',

  props: ['year', 'month', 'itemId'],

  data() {
    const item = create({
      date: DateTime.local().toFormat('yyyy-MM-dd')
    })
    item.amount = ''

    return {
      item,
      categories: [],
      typeOptions: [
        {
          label: 'Expense',
          value: ITEM_TYPE.EXPENSE
        },
        {
          label: 'Income',
          value: ITEM_TYPE.INCOME
        }
      ]
    }
  },

  methods: {
    handleCancel() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },

    async handleRemove() {
      await remove(this.year, this.month, this.itemId)
      this.$router.go(-1)
    },

    async handleSave() {
      await save(this.item)
      this.$router.go(-1)
    }
  },

  mounted() {
    listCategories().then(categories => {
      this.categories = categories
    })

    if (this.itemId) {
      getById(this.year, this.month, this.itemId)
        .then((item) => this.item = item)
    }
  }
}
</script>

<style scoped>
.form-element {
  width: 290px;
}

footer {
  margin: 24px 0;
}
</style>
